<section class="comp-leave-history">

  <div *ngIf="request?.displayOnPage">
    <div class="p-grid" style="margin-top:15px;">

    <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Year*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown [placeholder]="Validation.DropdownPlaceholder" styleClass="leave-bal-drop"
                        [options]="yearDropdown"
                        [(ngModel)]="request.year"
                        (onChange)="getLeaveHistory(request)"></p-dropdown>
          </div>
        </div>
      </div>
      <div *ngIf="request.userType===LeaveHistoryUserType.Manager" class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Your Employee*</label>
          </div>
          <div *ngIf="request.userType===LeaveHistoryUserType.Manager" class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown name="employee" [placeholder]="Validation.DropdownPlaceholder" [options]="subordinateDropdown" [filter]="true"
                        [(ngModel)]="selectedEmployee" (onChange)="onChangeEmployee(selectedEmployee)"></p-dropdown>
          </div>
        </div>
      </div>

      <div *ngIf="allowManualEdit&&user?.hasRole[Roles.HrGeneralist]" class="p-col-12 p-md-6 p-lg-6" style="text-align:right">
        <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Adjustment" [pTooltip]="newLeaveAdjustmentTooltip" tooltipPosition="top"
                (click)="onClickAddLeaveAdjustment(leaveHistories[0])">
        </button>
        <button *ngIf="!(selectedLeaveHistory&&selectedLeaveHistory[0]?.id)"
                pButton type="button" class="action-secondary" icon="fa fa-plus" label="Beginning Balance" pTooltip="Init Beginning Balance" tooltipPosition="top"
                (click)="onClickInitBeginningBalance(selectedLeaveHistory[0])">
        </button>
      </div>
    </div>

    <app-data-table [value]="selectedLeaveHistory" [disableSearch]="false" [disablePagination]="true"
                    [headerTemplate]="leaveHistoryHeader" [bodyTemplate]="leaveHistoryBody" [globalFilterFields]="">

      <ng-template #leaveHistoryHeader>
        <tr>
          <th>Type</th>
          <th>Beginning Balance</th>
          <th>YTD Taken</th>
          <th>YTD Accrual</th>
          <th>YTD Adjustment</th>
          <th>Ending Balance</th>
          <th>Details</th>
        </tr>
      </ng-template>

      <ng-template #leaveHistoryBody let-leave="row" let-columns="columns">
        <tr *ngIf="combinedPool" [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.PTO | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{leave.beginPTOBalance}}</span>
          </td>
          <td>
            <span class="p-column-title">TYD Taken</span>
            <span class="p-cell">{{leave.ytdPTOTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{leave.ytdPTOAccrued}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdPTOAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{leave.endingPTOBalance}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.PTO]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.PTO)">
              </button>

              <!--            jC: This is an alternate way to update the beginning balance. Commented out for now.-->
              <!--            <button pButton type="button" icon="fa fa-pencil" iconPos="center" pTooltip="Change Beginning Balance"-->
              <!--                    (click)="OnClickChangeBeginningBalance(selectedLeaveHistory[0])">-->
              <!--            </button>-->

            </span>
          </td>
        </tr>
        <tr *ngIf="!combinedPool" [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Sick | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{leave.beginSickBalance}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell"> {{leave.ytdSickTaken}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrued</span>
            <span class="p-cell"> {{leave.ytdSickAccrued}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell"> {{leave.ytdSickAdjustment}} </span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell"> {{leave.endingSickBalance}} </span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Sick]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Sick)">
              </button>
            </span>
          </td>
        </tr>
        <tr *ngIf="!combinedPool" [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Vacation | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell"> {{leave.beginVacationBalance}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell"> {{leave.ytdVacationTaken}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell"> {{leave.ytdVacationAccrued}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell"> {{leave.ytdVacationAdjustment}} </span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell"> {{leave.endingVacationBalance}} </span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Vacation]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Vacation)">
              </button>
            </span>
          </td>
        </tr>
        <tr [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Bereavement | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave?.ytdBereavementTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave?.ytdBereavementAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Bereavement]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Bereavement)">
              </button>
            </span>
          </td>
        </tr>
        <tr [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.FMLA | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdFMLATaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdFMLAAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell"></span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.FMLA]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.FMLA)">
              </button>
            </span>
          </td>
        </tr>
        <tr [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Jury | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdJuryTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdJuryAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Jury]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Jury)">
              </button>
            </span>
          </td>
        </tr>
        <tr [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.LOA | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdLOATaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdLOAAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.LOA]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.LOA)">
              </button>
            </span>
          </td>
        </tr>
        <tr [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Military | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdMilitaryTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdMilitaryAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Military]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Military)">
              </button>
            </span>
          </td>
        </tr>
        <tr [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.LWOP | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdLWOPTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdLWOPAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.LWOP]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.LWOP)">
              </button>
            </span>
          </td>
        </tr>
        <tr [pSelectableRow]="leave">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Holiday | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{leave?.beginHolidayBalance}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdHolidayTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdHolidayAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{leave?.endingHolidayBalance}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Holiday]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Holiday)">
              </button>
            </span>
          </td>
        </tr>
      </ng-template>
    </app-data-table>
  </div>

  <!-- popup dialog showing leave history -->
  <p-dialog *ngIf="displayLeaveHistoryDialog" [(visible)]="displayLeaveHistoryDialog"
            header="Leave History" [modal]="true" [dismissableMask]="true" [responsive]="true" [style]="DialogStyle700">
    <div class="p-grid">
      <div class="p-col-1">
        <label>Year*</label>
      </div>
      <div class="p-col-1">
        <p-dropdown *ngIf="request" [placeholder]="Validation.DropdownPlaceholder"
                    [options]="yearDropdown" [(ngModel)]="request.year"
                    (onChange)="getLeaveHistory(request)"></p-dropdown>
      </div>
    </div>

    <app-data-table [value]="selectedLeaveHistory"
                    [headerTemplate]="selectedHistoryHeader" [bodyTemplate]="selectedLeaveBody">
      <ng-template #selectedHistoryHeader>
        <tr>
          <th>Type</th>
          <th>Beginning Balance</th>
          <th>YTD Taken</th>
          <th>YTD Accrual</th>
          <th>YTD Adjustment</th>
          <th>Ending Balance</th>
          <th>Action</th>
        </tr>
      </ng-template>

      <ng-template #selectedLeaveBody let-leave="row">
        <tr *ngIf="combinedPool">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.PTO | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell"> {{leave.beginPTOBalance}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell"> {{leave.ytdPTOTaken}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell"> {{leave.ytdPTOAccrued}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell"> {{leave.ytdPTOAdjustment}} </span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell"> {{leave.endingPTOBalance}} </span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.PTO]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.PTO)">
              </button>
            </span>
          </td>
        </tr>
        <tr *ngIf="!combinedPool">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Sick | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell"> {{leave.beginSickBalance}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell"> {{leave.ytdSickTaken}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell"> {{leave.ytdSickAccrued}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell"> {{leave.ytdSickAdjustment}} </span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell"> {{leave.endingSickBalance}} </span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Sick]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Sick)">
              </button>
            </span>
          </td>
        </tr>
        <tr *ngIf="!combinedPool">
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Vacation | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell"> {{leave.beginVacationBalance}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell"> {{leave.ytdVacationTaken}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell"> {{leave.ytdVacationAccrued}} </span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell"> {{leave.ytdVacationAdjustment}} </span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell"> {{leave.endingVacationBalance}} </span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Vacation]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Vacation)">
              </button>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Bereavement | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdBereavementTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdBereavementAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Bereavement]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Bereavement)">
              </button>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.FMLA | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdFMLATaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdFMLAAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.FMLA]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.FMLA)">
              </button>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Jury | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdJuryTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdJuryAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Jury]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Jury)">
              </button>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.LOA | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdLOATaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdLOAAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.LOA]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.LOA)">
              </button>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Military | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdMilitaryTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdMilitaryAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Military]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Military)">
              </button>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.LWOP | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdLWOPTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdLWOPAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.LWOP]>0" pButton type="button" icon="fa fa-external-link" iconPos="center"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.LWOP)">
              </button>
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="p-column-title">Type</span>
            <span class="p-cell">{{CombinedLeaveType.Holiday | titleCase:NoTitlecaseCombinedLeaveType}}</span>
          </td>
          <td>
            <span class="p-column-title">Beginning Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Taken</span>
            <span class="p-cell">{{leave.ytdHolidayTaken}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Accrual</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">YTD Adjustment</span>
            <span class="p-cell">{{leave.ytdHolidayAdjustment}}</span>
          </td>
          <td>
            <span class="p-column-title">Ending Balance</span>
            <span class="p-cell">{{Validation.NotApplicable}}</span>
          </td>
          <td>
            <span class="p-column-title">Details</span>
            <span class="p-cell">
              <button *ngIf="leaveDetailsLengths[CombinedLeaveType.Holiday]>0" pButton type="button" icon="fa fa-external-link" iconPos="center" pTooltip="View Detail"
                      pTooltip="View Detail"
                      (click)="showLeaveDetailsByType(leave, CombinedLeaveType.Holiday)">
              </button>
            </span>
          </td>
        </tr>
      </ng-template>
    </app-data-table>
    <p-footer>
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close" style="margin-top:10px;" (click)="displayLeaveHistoryDialog=false"></button>
    </p-footer>
  </p-dialog>

  <!-- popup dialog showing leave details -->
  <p-dialog *ngIf="selectedLeaveDetails&&displayLeaveDetailsDialog" [(visible)]="displayLeaveDetailsDialog" header="Leave Details" [modal]="true" [dismissableMask]="true" [responsive]="true"
            [style]="DialogStyle700"
            appendTo="body" [contentStyle]="{'overflow':'scroll'}">

    <app-data-table [value]="selectedLeaveDetails" sortField="actionOn" [headerTemplate]="leaveDetailsHeader" [bodyTemplate]="leaveDetailsBody" [globalFilterFields]="['timesheetPeriodAsString',
    'leaveType', 'actionType', 'hours']">

      <ng-template #leaveDetailsHeader>
        <tr>
          <th [pSortableColumn]="'actionOn'">Processed Date
            <p-sortIcon field="actionOn"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'timesheetPeriodAsString'">Timesheet Period
            <p-sortIcon field="timesheetPeriodAsString"></p-sortIcon>
          </th>
          <th>Leave Type</th>
          <th>Action Type</th>
          <th>Reason</th>
          <th>Include in YTD Calculations</th>
          <th>Hours</th>
          <th *ngIf="isLeaveAdjustmentAllowed">Action</th>
        </tr>
      </ng-template>

      <ng-template #leaveDetailsBody let-leaveDetails="row">
        <tr>
          <td>
            <span class="p-column-title">Date</span>
            <span class="p-cell"> {{leaveDetails.actionOn }} </span>
          </td>
          <td>
            <span class="p-column-title">Timesheet Period</span>
            <span class="p-cell"> {{leaveDetails.timesheetPeriodAsString}} </span>
          </td>
          <td>
            <span class="p-column-title">Leave Type</span>
            <span class="p-cell"> {{leaveDetails.leaveType | titleCase:NoTitlecaseCombinedLeaveType}} </span>
          </td>
          <td>
            <span class="p-column-title">Action Type</span>
            <span class="p-cell"> {{leaveDetails.actionType | stringReplace:LabelChangeLeaveActionType:true}} </span>
          </td>
          <td>
            <span class="p-column-title">Reason</span>
            <span class="p-cell"> {{leaveDetails.reason}} </span>
          </td>
          <td>
            <span class="p-column-title">Reason</span>

            <span class="p-cell"> <p-checkbox [binary]="true" [(ngModel)]="leaveDetails.includeInCalculations" [disabled]="true"></p-checkbox></span>
          </td>
          <td>
            <span class="p-column-title">Hours</span>
            <span class="p-cell"> {{leaveDetails.hours}} </span>
          </td>
          <td *ngIf="isLeaveAdjustmentAllowed">
            <span class="p-column-title">Details</span>
            <span class="p-cell"> {{leaveDetails.hours}}
              <button *ngIf="request?.userType===LeaveHistoryUserType.User&&leaveDetails.id&&leaveDetails.actionType===LeaveActionType.Adjustment"
                      pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Edit Leave Adjustment" tooltipPosition="top"
                      (click)="onClickEditLeaveDetail(selectedLeaveHistory[0]?.combinedPool, leaveDetails)">
              </button>
              <button *ngIf="request?.userType===LeaveHistoryUserType.User&&leaveDetails.id&&leaveDetails.actionType===LeaveActionType.BegBalance"
                      pButton type="button" class="icon-action" icon="fa fa-info-circle" pTooltip="Beginning Balance cannot be changed. Please make adjustment as needed." tooltipPosition="top">
              </button>
              <button *ngIf="request?.userType===LeaveHistoryUserType.User&&leaveDetails.id&&leaveDetails.actionType===LeaveActionType.Adjustment"
                      pButton type="button" class="icon-action" icon="fa fa-trash" pTooltip="Delete Leave Adjustment" tooltipPosition="top"
                      (click)="onClickDeleteLeaveDetail(leaveDetails)">
              </button>
            </span>
          </td>
        </tr>
      </ng-template>
    </app-data-table>

    <p-footer>
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close" style="margin-top:10px;" (click)="displayLeaveDetailsDialog=false"></button>
    </p-footer>
  </p-dialog>


  <p-dialog *ngIf="leaveHistoryToEdit&&displayBeginningBalanceDialog" [(visible)]="displayBeginningBalanceDialog"
            header="Initialize Beginning Balance" [modal]="true" [dismissableMask]="true" [responsive]="true" [style]="DialogStyle40">

    <div class="instruction-text">
      Please keep in mind that OneLynk does NOT make a GL entry for a manual beginning balance change. You must make the accompanying GL entry for this change to
      ensure the associated account balance remains accurate.
    </div>

    <form class="p-grid" #beginningBalanceForm="ngForm">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Year</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{leaveHistoryToEdit.year}}
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Combined Pool
            <button pButton class="icon-action" icon="fa fa-info-circle" pTooltip="Suggested based on the assigned Employee Class and PTO policy." tooltipPosition="top"></button>
          </label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-checkbox name="combinedPool" binary="true"
                      [(ngModel)]="leaveHistoryToEdit.combinedPool"></p-checkbox>
        </div>
      </div>

      <div *ngIf="leaveHistoryToEdit.combinedPool" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Beginning PTO Balance*
            <button pButton type="button" class="icon-action" icon="fa fa-info-circle" pTooltip="Allowed #: [+|-] 9999.99" tooltipPosition="top"></button>
          </label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="beginPtoBalance" type="text" [pattern]="RegExp4DigitWhole2DigitFraction"
                 [(ngModel)]="leaveHistoryToEdit.beginPTOBalance" required/>
        </div>
      </div>
      <div *ngIf="!leaveHistoryToEdit.combinedPool" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Beginning Vacation Balance*
            <button pButton type="button" class="icon-action" icon="fa fa-info-circle" pTooltip="Allowed #: [+|-] 9999.99" tooltipPosition="top"></button>
          </label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="beginVacBalance" type="text" [pattern]="RegExp4DigitWhole2DigitFraction"
                 [(ngModel)]="leaveHistoryToEdit.beginVacationBalance" required/>
        </div>
      </div>
      <div *ngIf="!leaveHistoryToEdit.combinedPool" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Beginning Sick Balance*
            <button pButton type="button" class="icon-action" icon="fa fa-info-circle" pTooltip="Allowed #: [+|-] 9999.99" tooltipPosition="top"></button>
          </label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="beginSickBalance" type="text" [pattern]="RegExp4DigitWhole2DigitFraction"
                 [(ngModel)]="leaveHistoryToEdit.beginSickBalance" required/>
        </div>
      </div>
    </form>

    <p-footer>
      <div style="margin-top:15px;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close"
                (click)="displayBeginningBalanceDialog=false"></button>
        <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
                (click)="onClickSaveBeginningBalance(leaveHistoryToEdit)"
                [disabled]="!beginningBalanceForm.valid">
        </button>
      </div>
    </p-footer>


  </p-dialog>

  <p-dialog *ngIf="leaveAdjustmentToEdit&&showLeaveAdjustmentDialog" [(visible)]="showLeaveAdjustmentDialog"
            header="Leave Adjustment" [modal]="true" [dismissableMask]="true" [responsive]="true" [style]="DialogStyle40">

    <div class="instruction-text">
      Please keep in mind that OneLynk does NOT make a GL entry for a manual leave adjustment or beginning balance change. You must make the accompanying GL entry for this change to
      ensure the associated account balance remains accurate.
    </div>

    <form class="p-grid" #dialogForm="ngForm">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Action*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          {{leaveAdjustmentToEdit.actionType | stringReplace:LabelChangeLeaveActionType:true}}
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Leave Type*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="leaveType" [placeholder]="Validation.DropdownPlaceholder" [style]="{ 'overflow': 'visible', 'width': '100%'}"
                      [options]="leaveTypeDropdown" [(ngModel)]="leaveAdjustmentToEdit.leaveType"
                      [disabled]="leaveAdjustmentToEdit.id" required></p-dropdown>
        </div>
      </div>

      <div *ngIf="leaveAdjustmentToEdit.actionType===LeaveActionType.Adjustment" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Timesheet Period</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="timesheetPeriod" [placeholder]="Validation.DropdownPlaceholder" [style]="{ 'overflow': 'visible', 'width':'100%'}"
                      [options]="timesheetPeriodDropdown"
                      [showClear]="true" [(ngModel)]="leaveAdjustmentToEdit.timesheetPeriodId"
                      (onChange)="onChangeTimesheetPeriod(leaveAdjustmentToEdit.timesheetPeriodId)"></p-dropdown>
        </div>
      </div>

      <div *ngIf="leaveAdjustmentToEdit.actionType===LeaveActionType.Adjustment" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Include in YTD Calculations</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-selectButton name="includeInCalculations" [options]="adjustmentOptions"
                          [(ngModel)]="leaveAdjustmentToEdit.includeInCalculations">
          </p-selectButton>
        </div>
      </div>

      <div *ngIf="leaveAdjustmentToEdit.actionType" class="p-grid">
        <div *ngIf="leaveAdjustmentToEdit.actionType===LeaveActionType.Adjustment" class="p-col-12 p-md-4 p-lg-4">
          <label>Leave Date*</label>
        </div>
        <div *ngIf="leaveAdjustmentToEdit.actionType===LeaveActionType.BegBalance" class="p-col-12 p-md-4 p-lg-4">
          <label>Changed Date*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-calendar id="actionOn" name="actionOn" dataType="string" [dateFormat]="Format.PcalendarDate" [minDate]="minLeaveOn" [maxDate]="maxLeaveOn" icon="fa fa-calendar"
                      showIcon="true"
                      readonlyInput="true" [monthNavigator]="true" [yearNavigator]="true"
                      [yearRange]="YearRange" [(ngModel)]="leaveAdjustmentToEdit.actionOn"
                      required #actionOn="ngModel"></p-calendar>
        </div>
      </div>

      <div *ngIf="leaveAdjustmentToEdit.actionType" class="p-grid">
        <div *ngIf="leaveAdjustmentToEdit.actionType===LeaveActionType.Adjustment" class="p-col-12 p-md-4 p-lg-4">
          <label>Hours*
            <button pButton type="button" class="icon-action" icon="fa fa-info-circle" pTooltip="Allowed #: [+|-] 9999.99" tooltipPosition="top"></button>
          </label>
        </div>
        <div *ngIf="leaveAdjustmentToEdit.actionType===LeaveActionType.BegBalance" class="p-col-12 p-md-4 p-lg-4">
          <label>Beginning Balance*
            <button pButton type="button" class="icon-action" icon="fa fa-info-circle" pTooltip="Allowed #: [+|-] 9999.99" tooltipPosition="top"></button>
          </label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="hours" type="text" [pattern]="RegExp4DigitWhole2DigitFraction"
                 [(ngModel)]="leaveAdjustmentToEdit.hours" required/>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Reason*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <textarea pInputTextarea name="leaveReason" rows="2" cols="40" [maxLength]="Validation.DescriptionMaxLength" style="width:100%;max-width:225px;"
                    [(ngModel)]="leaveAdjustmentToEdit.reason" required></textarea>
          <div *ngIf="leaveAdjustmentToEdit?.reason?.length >= Validation.DescriptionMaxLength" class="alert alert-danger" style="width:225px;">
            {{Validation.MaxNumOfCharsExceeded}}
          </div>
        </div>
      </div>
    </form>

    <p-footer>
      <div style="margin-top:15px;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close" (click)="showLeaveAdjustmentDialog=false"></button>
        <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
                (click)="onSaveLeaveDetail(leaveAdjustmentToEdit)"
                [disabled]="!dialogForm.valid">
        </button>
      </div>
    </p-footer>
  </p-dialog>

  <p-confirmDialog header="Confirmation" icon="fa fa-question-circle"></p-confirmDialog>

</section>
